export function getView(display_options) {
  return display_options ? 'HideAction' : 'ShowAction'
}
